/**
 *
 * ReleaseOverview
 *
 */

import React, { createContext, useMemo } from 'react';

// api
import { Invoice } from 'lib/api/invoice';

// ui
import { Flex } from '@domonda/ui';

// parts
import { ReleaseOverviewRowHeader, ReleaseOverviewRow } from './ReleaseOverviewRow';

export interface ReleaseOverviewContextValue {
  invoices: Invoice[];
  selectedInvoiceIds: string[];
  onCheckInvoice: (
    invoiceId: UUID | undefined,
  ) => ({ currentTarget }: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ReleaseOverviewContext = createContext<ReleaseOverviewContextValue>({
  invoices: [],
  selectedInvoiceIds: [],
  onCheckInvoice: () => () => {},
});

export interface ReleaseOverviewProps {
  invoices: Invoice[];
  selectedInvoiceIds: UUID[];
  onChangeSelectedInvoiceIds: (updater: (selectedInvoiceIds: UUID[]) => UUID[]) => void;
}

const ReleaseOverview: React.FC<ReleaseOverviewProps> = (props) => {
  const { invoices, selectedInvoiceIds, onChangeSelectedInvoiceIds } = props;

  const onCheckInvoice = (invoiceId: UUID | undefined) => ({
    currentTarget,
  }: React.ChangeEvent<HTMLInputElement>) => {
    onChangeSelectedInvoiceIds((selected) => {
      if (currentTarget.checked) {
        if (invoiceId) {
          return [...selected, invoiceId];
        }
        return invoices.map(({ InvoiceId }) => InvoiceId);
      }

      if (invoiceId) {
        return selected.filter((selectedInvoiceId) => selectedInvoiceId !== invoiceId);
      }
      return [];
    });
  };

  const rows = useMemo(
    () => invoices.map((invoice) => <ReleaseOverviewRow key={invoice.InvoiceId} item={invoice} />),
    [invoices, selectedInvoiceIds],
  );

  return (
    <ReleaseOverviewContext.Provider value={{ invoices, selectedInvoiceIds, onCheckInvoice }}>
      <Flex container direction="column">
        <Flex item>
          <ReleaseOverviewRowHeader />
          {rows}
        </Flex>
      </Flex>
    </ReleaseOverviewContext.Provider>
  );
};

const ComposedReleaseOverview = ReleaseOverview;
export { ComposedReleaseOverview as ReleaseOverview };
